import { render, staticRenderFns } from "./BoxQuizHistory.vue?vue&type=template&id=4c8e28d8&"
import script from "./BoxQuizHistory.vue?vue&type=script&lang=js&"
export * from "./BoxQuizHistory.vue?vue&type=script&lang=js&"
import style0 from "./BoxQuizHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports